/**
 * Đăng ký sớm Service Worker bài giảng để lần đầu bấm «Trình chiếu» trang thường đã có controller
 * (ghi IndexedDB + phục vụ /__ima-lesson/ — tránh store files rỗng do chưa claim kịp).
 * Trùng đường dẫn với imaLessonSwPresentation.js / public/ima-lesson-sw.js
 */
const SW_SCRIPT = "/ima-lesson-sw.js";

if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.register(SW_SCRIPT, { scope: "/" }).catch(() => {});
}
